export type ExternalActivityStatus = "available" | "consumed";

export default class ExternalActivityModel {
  public id: string = "";
  public datetime: string = "";
  public status: ExternalActivityStatus = "available";
}
